import { render, staticRenderFns } from "./add.vue?vue&type=template&id=d63a51ea&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=d63a51ea&scoped=true&lang=css&"
import style1 from "./add.vue?vue&type=style&index=1&id=d63a51ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63a51ea",
  null
  
)

export default component.exports